import { Link } from 'react-router-dom'
import successIcon from '../../images/success.svg'

function BvnConsentSuccessPage() {
  return (
    <div className='min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4'>
      <div className='max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center'>
        {/* Success Icon */}
        <div className='mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-green-100 mb-6'>
          {/* Font Awesome Icon as primary, with SVG fallback */}
          <i className='fas fa-check-circle text-green-500 text-5xl' />
          {/* SVG Fallback - only shows if Font Awesome fails */}
          <noscript>
            <img
              src={successIcon}
              alt='Success'
              className='h-12 w-12'
              onError={e => {
                e.target.style.display = 'none'
              }}
            />
          </noscript>
        </div>

        {/* Success Message */}
        <h1 className='text-2xl font-bold text-gray-900 mb-3'>BVN Consent Granted Successfully!</h1>

        <p className='text-gray-600 mb-8'>
          Thank you for granting consent. Your BVN verification process has been completed
          successfully.
        </p>

        {/* Illustration */}
        <div className='mb-8'>
          <img
            src='/images/success-illustration.svg'
            alt='Success Illustration'
            className='w-64 h-64 mx-auto'
          />
        </div>

        {/* Action Button */}
        <Link
          to='/'
          className='inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-colors duration-200'
        >
          Return to Homepage
        </Link>
      </div>
    </div>
  )
}

export default BvnConsentSuccessPage
